import React, { PureComponent } from 'react'
import { Button, Paper, ListItem, Grid } from '@material-ui/core'

// local components
import EditActionComponent from '../common/EditActionComponent'
import { EditableTextField } from '../common/EditableComponents'

class ApiUrl extends PureComponent {
  onSave = () => {
    this.props.onSave()
  }

  onCancel = () => {
    this.props.onCancel()
    this.props.disableEdit()
  }

  onChange = (e) => {
    this.props.updateApiUrl(e)
  }

  onClear = () => {
    this.props.onClear()
  }

  render() {
    const { editMode, apiUrl } = this.props

    return (
      <Grid container>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <div className="pull-right margin-bottom-small">
            <EditActionComponent
              onSave={this.onSave}
              onCancel={this.onCancel}
              onEdit={this.props.enableEdit}
              editMode={editMode}
            />
            {!editMode ? (
              <Button className="danger-button margin" onClick={this.onClear}>
                Clear
              </Button>
            ) : null}
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Paper className="paper-page">
            <ListItem>
              <Grid container>
                <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                  API URL
                </Grid>
                <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                  <EditableTextField
                    valueToRender={apiUrl}
                    editMode={editMode}
                    value={apiUrl}
                    onChange={this.onChange}
                    type="text"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
              </Grid>
            </ListItem>
          </Paper>
        </Grid>
      </Grid>
    )
  }
}

export default ApiUrl



// WEBPACK FOOTER //
// ./src/components/ApiUrl/ApiUrlInfo.js